/*
 * @Description: 进项管理
 * @Author: lijinpeng
 * @Date: 2022-10-21 16:46:05
 * @LastEditTime: 2023-09-19 14:43:30
 * @LastEditors: WangYuhan
 */

import { get, post, prefix } from './base';

// 获取油款票列表
export function getSalesReceiptList(params) {
  return get(`${prefix}wanjinyou/salesReceiptList`, params);
}

// 获取油款可开发票金额
export function getOilAvailableAmount(val) {
  return get(`${prefix}wanjinyou/getAvailableAmount`, val);
}

// 申请开油款票
export function getOilInvoiceApply(params) {
  return get(`${prefix}wanjinyou/invoiceApply`, params);
}

// 网货服务费列表
export function getApplyServiceFeeBillList(params) {
  return get(`${prefix}admin/apply_service_fee_bill_list`, params);
}

// 网货服务费统计
export function getApplyServiceFeeBillListCount(params) {
  return get(`${prefix}admin/apply_service_fee_bill_list_count`, params);
}

//申请服务费-导出
export const applyServiceFeeBillListExport = `${prefix}admin/apply_service_fee_bill_list_export`;

// 开票信息回显
export function invoiceUpdateBefore(params) {
  return get(`${prefix}corporaInvoice/updateBefore`, params);
}

// 获取网货服务费可开票金额
export function getApplyInvoiceInfo(params) {
  return post(`${prefix}admin/get_apply_invoice_info`, params);
}

// 网湖服务费申请开票
export function serviceFeeApplyInvoice(params) {
  return post(`${prefix}admin/service_fee_apply_invoice`, params);
}

// 网货服务费发票列表
export function getServiceFeeInvoiceList(params) {
  return get(`${prefix}admin/service_fee_invoice_list`, params);
}

// 网货服务费发票统计
export function getServiceFeeInvoiceListCount(params) {
  return get(`${prefix}admin/service_fee_invoice_list_count`, params);
}

//服务费发票-导出
export const serviceFeeInvoiceListExport = `${prefix}admin/service_fee_invoice_list_export`;

export function postNetGoodsInvoiceList(data) {
  return post(`${prefix}network/freight/query`, data);
}

// 获取网货发票开票状态统计信息
export function getNetGoodsInvoiceStatistics(params) {
  return get(`${prefix}network/freight/invoicing_status`, params);
}

// 申请开票
export function applyFromOneStop(val) {
  return post(`${prefix}admin/waybillInvoice/applyFromOneStop`, val);
}

// 网货发票导出
export const netGoodsInvoiceExportUrl = `${prefix}network/freight/export`;
